var React = require('react');

function IcAwsS3Object (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Art"},React.createElement("g",null,React.createElement("path",{"className":"st0","d":"M20,40C8.972,40,0,31.028,0,20S8.972,0,20,0c11.029,0,20,8.972,20,20S31.028,40,20,40z M20,1.933\n\t\t\tC10.038,1.933,1.933,10.038,1.933,20S10.038,38.067,20,38.067S38.067,29.962,38.067,20S29.962,1.933,20,1.933z"}))));
}

IcAwsS3Object.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 40 40","style":{"enableBackground":"new 0 0 40 40"},"xmlSpace":"preserve"};

module.exports = IcAwsS3Object;

IcAwsS3Object.default = IcAwsS3Object;
